import { IconProps } from "@/types/common";
import React from "react";

const HamburgerChevronIcon: React.FC<IconProps> = ({ className }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M23.3596 16.9242C23.7194 17.3118 23.7151 17.9125 23.35 18.295L22.8477 18.8211C22.4522 19.2354 21.79 19.2334 21.3969 18.8166L16.087 13.1861C15.7237 12.8008 15.7237 12.1992 16.087 11.8139L21.3969 6.18338C21.79 5.7666 22.4522 5.76457 22.8478 6.17893L23.35 6.70497C23.7151 7.08747 23.7194 7.68818 23.3596 8.07579L19.8847 11.8197C19.5287 12.2034 19.5287 12.7966 19.8847 13.1803L23.3596 16.9242ZM0 5C0 4.44771 0.447715 4 1 4H16.3333C16.8856 4 17.3333 4.44772 17.3333 5V5.83333C17.3333 6.38562 16.8856 6.83333 16.3333 6.83333H1C0.447716 6.83333 0 6.38562 0 5.83333V5ZM0.999999 13.9167C0.447714 13.9167 0 13.469 0 12.9167V12.0833C0 11.531 0.447715 11.0833 1 11.0833H12.3333C12.8856 11.0833 13.3333 11.531 13.3333 12.0833V12.9167C13.3333 13.469 12.8856 13.9167 12.3333 13.9167H0.999999ZM1 21C0.447716 21 0 20.5523 0 20V19.1667C0 18.6144 0.447715 18.1667 1 18.1667H16.3333C16.8856 18.1667 17.3333 18.6144 17.3333 19.1667V20C17.3333 20.5523 16.8856 21 16.3333 21H1Z" />
    </svg>
  );
};

export default HamburgerChevronIcon;
